function base64UrlDecode(str) {
  const pad = "===".slice((str.length + 3) % 4);
  const base64 = (str + pad).replace(/-/g, "+").replace(/_/g, "/");
  try {
    return decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
  } catch (e) {
    try {
      return atob(base64);
    } catch (_) {
      return "";
    }
  }
}

function getJwtPayloadFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("auth_token");
    if (!token) return null;
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const payloadJson = base64UrlDecode(parts[1]);
    return JSON.parse(payloadJson || "{}");
  } catch (e) {
    return null;
  }
}

export function getEntitlementsFromUrlJwt() {
  const payload = getJwtPayloadFromUrl();
  if (!payload) return {};
  const ctx = payload.ctx || {};
  const features = ctx.features || {};
  return typeof features === "object" && features !== null ? features : {};
}

export function getAvatarFromUrlJwt() {
  const payload = getJwtPayloadFromUrl();
  if (!payload) return null;
  const ctx = payload.ctx || {};
  return ctx.avatar || null;
}

export function getContextFromUrlJwt() {
  const payload = getJwtPayloadFromUrl();
  if (!payload) return {};
  return payload.ctx || {};
}

export function getUserInfoFromUrlJwt() {
  const payload = getJwtPayloadFromUrl();
  if (!payload) return null;
  return {
    userId: payload.user_id,
    role: payload.role,
    roomId: payload.room_id,
    avatar: payload.ctx?.avatar,
    features: payload.ctx?.features || {}
  };
}
